import React from 'react'

import { Field } from 'formik'

import { Col, Form, Button } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

import { CrudDatoPresupuestoModal } from 'sharedComponents/modals'

const DatoPresupuestoNivel2FormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const [datosPresupuestosOptions, setDatosPresupuestosOptions] = React.useState([])
  const [mostrarPresupuestoCrudModal, setMostrarPresupuestoCrudModal] = React.useState(false)

  const refrescarSelect = React.useCallback(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.DATOPRESUPUESTO_NIVEL2).then(({ data }) => {
      if (data && data.length > 0) {
        if (data.length === 1) {
          const primeraOpcion = data[0]
          setFieldValue('datoPresupuestoNivel2', primeraOpcion._id)
        }

        setDatosPresupuestosOptions(
          data.map((x, k) => (
            <option key={k} value={x._id}>
              {x.nombre}
            </option>
          ))
        )
      }
    })
  }, [setFieldValue])

  React.useEffect(() => {
    refrescarSelect()
  }, [refrescarSelect])

  return (
    <>
      <Form.Group>
        <Form.Label text='NIVEL 2' htmlFor='select-datoPresupuestoNivel2' md={12} />
        <Col md={12}>
          <Form.InputGroup>
            <Field name='datoPresupuestoNivel2'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  id='select-datoPresupuestoNivel2'
                  isInvalid={iTouched && iError}
                  disabled={fIsSubmitting}
                >
                  <option value=''>Seleccionar</option>
                  {datosPresupuestosOptions}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarPresupuestoCrudModal(true)}>O</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarPresupuestoCrudModal && (
        <CrudDatoPresupuestoModal
          handleClose={() => {
            setMostrarPresupuestoCrudModal(false)
            refrescarSelect()
          }}
          show={mostrarPresupuestoCrudModal}
          tipo={TiposTablaComunConstant.DATOPRESUPUESTO_NIVEL2}
        />
      )}
    </>
  )
}

export default React.memo(DatoPresupuestoNivel2FormGroup)
